import { Route, Navigate } from "react-router-dom";

import VendorLogin from "../pages/VendorPortal/VendorLogin";
import VendorPortalDashboard from "../pages/VendorPortal/VendorDashboard";
import VendorChat from "../pages/VendorPortal/VendorChat";
import VendorForgotPassword from "../pages/VendorPortal/VendorForgotPassword";
import VerifyVendorEmail from "../components/Vendor/VerifyVendorEmail";

// New Vendor Dashboard Pages
import {VendorDashboard,VendorTasks,VendorIssues,VendorCoVendors,VendorProfile,
} from "../pages/Vendor";
import VendorTimeTracking from "../pages/Vendor/VendorTimeTracking";
import VendorLayout from "../components/Vendor/VendorLayout";
import VendorContracts from "../components/Vendor/VendorContracts";
import VendorsProjectsList from "../pages/Vendors/VendorProjects";
import ApprovalsVendor from "../components/Vendor/ApprovalsVendor";


export default function VendorRoutes() {
  return (
    <>
    <Route path="/" element={<Navigate to="/vendor/login" replace />} />
      <Route path="/vendor/login" element={<VendorLogin />} />
      <Route path="/vendor/forgot-password" element={<VendorForgotPassword />} />
      <Route path="/vendor/chat/:conversationId" element={<VendorChat />} />
      <Route path="/vendor/verify_mail" element={<VerifyVendorEmail />} />

      {/* Vendor Dashboard with Layout */}
      <Route path="/vendor" element={<VendorLayout />}>
        <Route index element={<Navigate to="/vendor/dashboard" replace />} />
        <Route path="dashboard" element={<VendorDashboard />} />
        <Route path="tasks" element={<VendorTasks />} />
        <Route path="issues" element={<VendorIssues />} />
        <Route path="co-vendors" element={<VendorCoVendors />} />
        <Route path="projects" element={<VendorsProjectsList />} />
        <Route path="portal" element={<VendorPortalDashboard />} />
        <Route path="profile" element={<VendorProfile />} />
        <Route path="contracts" element={<VendorContracts />} />
        <Route path="time-tracking" element={<VendorTimeTracking />} />
        <Route path="approvals-vendor" element={<ApprovalsVendor />} />
      </Route>

      {/* Add vendor routes */}
    </>
  );
}